module.exports = __webpack_public_path__ + "static/media/rgError.7f1071fc.jpg";